export const BeneficiaryTypes = [
    { value: 'Organisation', label: 'Organisation' },
    { value: 'Individual', label: 'Individual' },
    { value: 'Estate', label: 'Estate' },
];
